var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('marque-form',{attrs:{"title":_vm.title,"submit-button-text":_vm.submitButtonText},on:{"submitMarqueForm":function($event){return _vm.onSubmit($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }